import { Project, ProjectStatus } from "datamodel/project";

const isProjectInProgress = (project: Project): boolean =>
  project.status === ProjectStatus.Processing ||
  project.status === ProjectStatus.Queued ||
  project.status === ProjectStatus.Waiting;

export default isProjectInProgress;
